import {ListComponentsHoteleria} from '../../components/components'
import {FC, useState} from 'react'
import {useHoteleria} from '../../../../hooks/useHoteleria'
import {TermsModel} from '../../features/tyc/models'
import {yupResolver} from '@hookform/resolvers/yup'
import {schemaTerms} from '../../../../util/validationHoteleria'
import {FormProvider, useForm} from 'react-hook-form'
import ContainerWrapper from '../../../central/pages/componentes/Container'
import {Panel, PanelGroup} from 'react-resizable-panels'
import {SnackbarProvider, enqueueSnackbar} from 'notistack'
import {ResizeHandle} from '../../components/Layout/Container/ResizeHandle/ResizeHandle'
import ActionsContent from '../components/Actions'
import {createTermsService, deleteTermsService, editTermsService} from '../../features/tyc/services'
import {TabModel} from '../../../../models'
import Swal from 'sweetalert2'
import {getSnackBar, getSnackBarToast} from '../../../../util/snackBar'

const renderPanelContent = (key: string | undefined) => {
  let component = <></>
  if (key) {
    component = ListComponentsHoteleria[key]
  }
  return component
}

const TyCPageWrapper: FC = () => {
  const {currentTabItem, changeCurrentTabItem} = useHoteleria()
  const [loading, setLoading] = useState(false)
  const methods = useForm<TermsModel>({
    resolver: yupResolver(schemaTerms),
  })

  const {
    formState: {errors},
  } = methods
  console.log(errors)
  const handleDelete = async () => {
    // debugger
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Al eliminar no podrás revertir esta acción',
      //showDenyButton: true,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, eliminar',
      confirmButtonColor: 'var(--kt-primary)',
      //denyButtonText: `Don't save`,
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        setLoading(true)
        let id = [{Id: currentTabItem.idToDelete}]
        changeCurrentTabItem({...currentTabItem, loadingTable: true, deleted: false})

        const data = await deleteTermsService(id)
        if (!data.data.error) {
          setLoading(false)

          const obj: TabModel = {
            ...currentTabItem,
            idToDelete: '',
            loadingTable: false,
            deleted: true,
          }
          changeCurrentTabItem(obj)
          getSnackBarToast('Se eliminó con éxito', 'success')
        } else {
          setLoading(false)
          changeCurrentTabItem({...currentTabItem, loadingTable: false, deleted: false})
          getSnackBarToast(data.data.message, 'error')
        }
        Swal.close()
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }

  const onSubmit = async (data: TermsModel) => {
    try {
      setLoading(true)
      let num1 = data.Campoadicionalnum1 ? Number(data.Campoadicionalnum1) : 0
      data.Campoadicionalnum1 = num1
      let num2 = data.Campoadicionalnum2 ? Number(data.Campoadicionalnum1) : 0
      data.Campoadicionalnum2 = num2
      let num3 = data.Campoadicionalnum3 ? Number(data.Campoadicionalnum1) : 0
      data.Campoadicionalnum3 = num3
      if (currentTabItem.idToEdit) {
        changeCurrentTabItem({...currentTabItem, loadingTable: true, updated: false})
        const response = await editTermsService(data)
        if (!response.data.error) {
          setLoading(false)
          getSnackBarToast('Se actualizó el registro correctamente', 'success')
          const obj: TabModel = {
            ...currentTabItem,
            showPanel: false,
            idToEdit: '',
            content: {
              ...currentTabItem.content,
              detailPanel: '',
            },
            loadingTable: false,
            updated: true,
          }
          changeCurrentTabItem(obj)
        } else {
          setLoading(false)
          changeCurrentTabItem({...currentTabItem, loadingTable: false, updated: false})
          getSnackBarToast(response.data.message, 'error')
        }
      } else {
        const response = await createTermsService(data)
        if (!response.data.error) {
          setLoading(false)
          getSnackBarToast('Se creó con éxito', 'success')
          const obj: TabModel = {
            ...currentTabItem,
            showPanel: false,
            idToEdit: '',
            content: {
              headerPanel: 'header-tyc',
            },
          }
          changeCurrentTabItem(obj)
        } else {
          let message = response?.data?.message?.toString() || ''
          enqueueSnackbar(message, {
            variant: 'error',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          })
          // setLoading(false)
          // getSnackBarToast(response.data.message, false)
        }
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }
  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <ActionsContent
          deleteClick={handleDelete}
          loading={loading}
          textComponentBack='header-tyc'
          textComponentGo='form-tyc'
        />
        <ContainerWrapper>
          <PanelGroup autoSaveId='example' direction='vertical'>
            <Panel
              collapsible={true}
              order={1}
              key={`panel-hoteleria-header-${currentTabItem.title}`}
              id={`panel-hoteleria-header-${currentTabItem.title}`}
              className={'panel__box'}
            >
              {renderPanelContent(currentTabItem.content.headerPanel)}
            </Panel>
            {currentTabItem.showPanel && (
              <>
                <ResizeHandle />
                <Panel
                  className={'panel__box'}
                  collapsible={true}
                  defaultSize={50}
                  order={2}
                  key={`panel-hoteleria-detail-${currentTabItem.title}`}
                  id={`panel-hoteleria-detail-${currentTabItem.title}`}
                >
                  {renderPanelContent(currentTabItem.content.detailPanel)}
                </Panel>
              </>
            )}
          </PanelGroup>
        </ContainerWrapper>
      </form>
      <SnackbarProvider />
    </FormProvider>
  )
}

export {TyCPageWrapper}
